import * as z from "zod";

export const createOmsNetsuiteIntegration = {
  name: "createOmsNetsuiteIntegration" as const,
  input: z.object({
    accountId: z.string(),
    clientId: z.string(),
    clientSecret: z.string(),
    token: z.string(),
    tokenSecret: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
